import firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";
import "firebase/firestore";
import "firebase/firebase-functions";

const firebaseConfig = {
  apiKey: "AIzaSyDfyLOjj76zC2IwommO6CdGHv-RC54xQu4",
  authDomain: "dev-stack-app.firebaseapp.com",
  databaseURL: "https://dev-stack-app.firebaseio.com",
  projectId: "dev-stack-app",
  storageBucket: "dev-stack-app.appspot.com",
  messagingSenderId: "728271783455",
  appId: "1:728271783455:web:956e62e836620fdb8eb72a",
  measurementId: "G-ZNP2LC7BEH",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

export default firebase;